import '@pixu-talks/core';

import './baseline-status/baseline-status.js';

// Customized built-ins used across slides
import './components/icon-button.js';
import './components/date-input.js';
import './components/collapsible-panel.js';
import './components/counter-button.js';
import './components/safe-link.js';

